class DatePicker {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    $('#currender_1').datepicker({dateFormat: 'yy年mm月dd日', minDate: "+3d"});

    $('#currender_2').datepicker({dateFormat: 'yy年mm月dd日', minDate: "+3d"});

    $('#currender_3').datepicker({dateFormat: 'yy年mm月dd日', minDate: "+3d"});
  }
}